import axios from "axios";

export default {
    read: (ctrl) => axios.get("/api/rights/read", ctrl && { signal: ctrl.signal }),
};
